import { returnsDefaultDiscountByWeightSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as z from "zod/v4";

export const saveDefaultDiscountTable = {
  name: "saveDefaultDiscountTable" as const,
  input: z.object({ discountTable: returnsDefaultDiscountByWeightSchema }),
  output: z.object({ discountTable: returnsDefaultDiscountByWeightSchema }),
};
